module.exports = __webpack_public_path__ + "public/media/digital-header-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-header-icon.png
// module id = ./images/services/digital-header-icon.png
// module chunks = 0